import { createActionCreator } from '../utils/helpers';
import { generateActions } from '../utils/HttpReducerHelper';
import { emailInvite, fundingReport, inviteLink } from './types';

export * from './convertToFundingSearch/actions';
export * from './delete/actions';
export * from './list/actions';
export * from './matches/actions';
export * from './resendInvite/actions';

export const requestFundingReport = createActionCreator(fundingReport.request, 'reportId');
export const requestFundingReportSuccess = createActionCreator(fundingReport.success, 'response');
export const requestFundingReportFailure = createActionCreator(fundingReport.failure, 'error');

export const sendEmailInvite = createActionCreator(emailInvite.request, 'payload', 'promise');

const inviteLinkHTTPActions = generateActions(inviteLink);
export const requestInviteLink = inviteLinkHTTPActions.request;
export const requestInviteLinkSuccess = inviteLinkHTTPActions.success;
export const requestInviteLinkFailure = inviteLinkHTTPActions.failure;
